import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Burger = (props: SVGIcon) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fillRule="evenodd"
      d="M27 24v2H8v-2h19zm-6-9v2H2v-2h19zm10-9v2H12V6h19z"
    />
  </svg>
)
